import { combineReducers } from "redux";
import { FormStateMap, reducer as formReducer } from "redux-form";
import { doctors } from "./doctors/reducer";
import { offices } from "./offices/reducers";
import { auth } from "./auth/reducers";
import tasks from "./task-queue/reducers";
import { doctor } from "./doctor/reducer";
import { users } from "./users/reducers";
import { user } from "./user/reducers";
import { bookings } from "./bookings/reducers";
import { professions } from "./professions/reducers";
import { profession } from "./profession/reducers";
import { searchUser } from "./search-users/reducers";
import { specialties } from "./specialties/reducers";
import { specialty } from "./specialty/reducers";
import { cities } from "./cities/reducers";
import { states } from "./states/reducers";
import { areas } from "./areas/reducers";
import { neighbourhoods } from "./neighbourhoods/reducers";
import { clinics } from "./clinics/reducers";
import { clinic } from "./clinic/reducers";
import { insurances } from "./insurances/reducers";
import { practices } from "./practices/reducers";
import { messages } from "./messages/reducers";
import { cooperations } from "./cooperations/reducers";
import { cooperation } from "./cooperation/reducers";
import { cooperationsOld } from "./cooperationsOld/reducers";
import { cooperationOld } from "./cooperationOld/reducers";
import { introductions } from "./introductions/reducers";
import { introduction } from "./introduction/reducers";
import { holidays } from "./holidays/reducers";
import { comments } from "./comments/reducers";
import view from "./view/reducers";
import { onlineConsult } from "./online-consult/reducers";
import { countries } from "./countries/reducers";
import { transactions } from "./transactions/index";
import { consult } from "./online-consult/consult/reducers";
import { consults } from "./online-consult/consults/reducers";
import { packages } from "./packages/reducers";
import { packageItem } from "./package/reducers";
import { contacts } from "./contacts/reducers";
import { contact } from "./contact/reducers";
import { taskResults } from "./task-results/reducers";
import { taskResult } from "./task-result/reducers";
import { doctorsPackages } from "./doctors-packages/reducers";
import { tickets } from "./tickets/reducers";
import { seoSettings } from "./seo-settings/reducers";
import { seoSetting } from "./seo-setting/reducers";
import { healthTags } from "./health-tags/reducers";
import { healthTag } from "./health-tag/reducers";
import { doctorsPackagesPayment } from "./doctors-package-payments/reducers";
import { doctorDocuments } from "./doctor-documents/reducers";
import { faq } from "./faq/reducers";
import { notifications } from "./notifications/reducers";
import { PersistConfig, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

const reducers = {
  form: formReducer,
  doctors,
  doctor,
  offices,
  profession,
  professions,
  specialty,
  specialties,
  insurances,
  practices,
  messages,
  comments,
  cooperations,
  cooperation,
  cooperationsOld,
  cooperationOld,
  introductions,
  introduction,
  users,
  user,
  bookings,
  searchUser,
  areas,
  neighbourhoods,
  cities,
  states,
  clinics,
  clinic,
  holidays,
  auth,
  tasks,
  view,
  onlineConsult,
  consult,
  consults,
  countries,
  transactions,
  packages,
  packageItem,
  contacts,
  contact,
  taskResults,
  taskResult,
  doctorsPackages,
  doctorDocuments,
  tickets,
  seoSettings,
  seoSetting,
  healthTags,
  healthTag,
  doctorsPackagesPayment,
  faq,
  notifications,
};
type Reducers = typeof reducers;

export type State = {
  [Property in keyof Reducers]: ReturnType<Reducers[Property]>;
};

const formPersistConfig: PersistConfig<FormStateMap> = {
  key: "root",
  storage,
  whitelist: [
    "addArea",
    "addCity",
    "addClinic",
    "add-contacts-method",
    "addCountry",
    "addOffice",
    "addVirtualOffice",
    "addPractice",
    "add-doctor",
    "addHealthTag",
    "addInsurance",
    "add-consult-package",
    "add-packages",
    "addPractice",
    "addProfession",
    "addSeoSetting",
    "addSpecialty",
    "addState",
    "add-currency",
    "add-payment-gateway",
    "add-user",
  ],
};

const formPersistedReducer = persistReducer<FormStateMap>(formPersistConfig, formReducer);
export const rootReducer = combineReducers({ ...reducers, form: formPersistedReducer });
